<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Edit Ship</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Edit Ship</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
         <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select @ionChange="shipChanged()" mode="ios" interface="action-sheet" v-model="shipId">
                <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id">{{ship.ship_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <template v-if="shipId!=''">
          <ion-item>
              <ion-label position="floating">Ship Name <span class="required">*</span></ion-label>
              <ion-input mode="ios" v-model="shipName"></ion-input>
          </ion-item>
          <ion-item>
              <ion-label position="floating">M Number <span class="required">*</span></ion-label>
              <ion-input mode="ios" v-model="mNumber"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Ship Capacity <span class="required">*</span></ion-label>
            <ion-text>
              Ship Capacity
            </ion-text>
              <ion-item v-for="(unit,i) of units" :key="i">
                <ion-label position="floating">{{unit.unit_name}} <span class="required">*</span></ion-label>
                <ion-input mode="ios" v-model="shipCapacity[''+unit.id]" type="number"></ion-input>
              </ion-item>
          </ion-item>
          <ion-item>
              <ion-label position="floating">Ship Type <span class="required">*</span></ion-label>
              <ion-select mode="ios" interface="action-sheet" v-model="shipType">
                  <ion-select-option v-for="(shipType,i) of shipTypes" :key="i" :value="shipType.id">{{shipType.ship_type_name}}</ion-select-option>
              </ion-select>
          </ion-item>
          <ion-item>
              <ion-label position="floating">Ship Category</ion-label>
              <ion-select mode="ios" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="shipCategory">
                  <ion-select-option v-for="(shipCategory,i) of shipCategories" :key="i" :value="shipCategory.id">{{shipCategory.ship_category_name}}</ion-select-option>
              </ion-select>
          </ion-item>
          <ion-item>
              <ion-label position="floating">Build Year</ion-label>
              <ion-select mode="ios" interface="action-sheet" v-model="buildYear">
                  <ion-select-option v-for="(year,i) of years" :key="i" :value="year">{{year}}</ion-select-option>
              </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Draft <small>(in Feet)</small> <span class="required">*</span></ion-label>
            <ion-input mode="ios"  v-model="maxDraft" type="number"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Length <small>(in Feet)</small> <span class="required">*</span></ion-label>
            <ion-input mode="ios"  v-model="length" type="number"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Beam <small>(in Feet)</small> <span class="required">*</span></ion-label>
            <ion-input mode="ios"  v-model="beam" type="number"></ion-input>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Gross Tonnage <small>(in Ton)</small> </ion-label>
            <ion-input mode="ios"  v-model="grossTonnage" type="number"></ion-input>
          </ion-item>
          <ion-item>
              <ion-label position="floating">Cargo Hold</ion-label>
              <ion-select mode="ios" interface="action-sheet" v-model="cargoHold">
                  <ion-select-option v-for="(cargoHold,i) of cargoHolds" :key="i" :value="i">{{cargoHold}}</ion-select-option>
              </ion-select>
          </ion-item>
          <ion-item>
              <ion-label position="floating">Fitness Certificate</ion-label>
              <ion-select mode="ios"  v-model="fitnessCertificate" interface="action-sheet">
                  <ion-select-option value="0">No</ion-select-option>
                  <ion-select-option value="1">Yes</ion-select-option>
              </ion-select>
          </ion-item>
          <ion-item>
            <ion-label position="floating">Fitness Certificate Details <span v-if="fitnessCertificate==1" class="required">*</span></ion-label>
            <ion-textarea  v-model="fitnessCertificateDetails"></ion-textarea>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Fitness Certificate Expires <span v-if="fitnessCertificate==1" class="required">*</span></ion-label>
          <ion-datetime mode="ios"  v-model="fitnessExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship Products <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="alert" :interface-options="{cssClass:'custom-multiple-select-layout'}"  multiple v-model="product">
                <ion-select-option v-for="(product,i) of products" :key="i" :value="product.id">{{product.product_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship Routes <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="alert" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="route">
                <ion-select-option v-for="(route,i) of routes" :key="i" :value="route.id">{{route.route_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship Groups <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="alert" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="shipGroup">
                <ion-select-option v-for="(shipGroup,i) of shipGroups" :key="i" :value="shipGroup.id">{{shipGroup.ship_group_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">Ship SMS Port Group <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" v-model="shipPortGroup">
                <ion-select-option v-for="(shipPortGroup,i) of shipPortGroups" :key="i" :value="shipPortGroup.id">{{shipPortGroup.port_group_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
            <ion-label position="floating">SOS Organization <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="alert" multiple :interface-options="{cssClass:'custom-multiple-select-layout'}" v-model="sosOrganization">
                <ion-select-option v-for="(sosOrganization,i) of sosOrganizations" :key="i" :value="sosOrganization.id">{{sosOrganization.sos_organization_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Survey Expire Date</ion-label>
          <ion-datetime mode="ios"  v-model="surveyExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Insurance Expire Date</ion-label>
          <ion-datetime mode="ios"  v-model="insuranceExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Bay Crossing Expire Date</ion-label>
          <ion-datetime mode="ios"  v-model="bayCrossingExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Protocol Expire Date</ion-label>
          <ion-datetime mode="ios"  v-model="protocolExpireDate" cancel-text="Clear" @ionCancel="clearDateTime" display-format="DD/MMM/YYYY" min="1950-01-01" max="2030-12-12"></ion-datetime>
        </ion-item>
        <ion-button expand="block" @click="save()" color="primary">Update</ion-button>
        </template>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonInput, IonItem, IonLabel,IonSelect,IonSelectOption,IonDatetime,alertController, IonText, IonTextarea } from '@ionic/vue';
export default {
  name: 'Edit Ship',
  props:[
      'draftId'
  ],
  data(){
    return {
      ships:[],
      shipId:'',
      mobile:'',
      shipName:'',
      mNumber:'',
      shipCapacity:[],
      buildYear:'',
      maxDraft:'',
      length:'',
      beam:'',
      grossTonnage:'',
      cargoHold:'',
      fitnessCertificate:'',
      fitnessCertificateDetails:'',
      fitnessExpireDate:'',
      surveyExpireDate:'',
      insuranceExpireDate:'',
      bayCrossingExpireDate:'',
      protocolExpireDate:'',
      years:[],
      cargoHolds:[],
      shipType:null,
      shipTypes:[],
      shipCategory:[],//multiple
      shipCategories:[],
      products:[],
      product:[], //multiple
      routes:[],
      route:[], //multiple
      shipGroups:[],
      shipGroup:[], //multiple
      shipPortGroups:[],
      shipPortGroup:null,
      sosOrganizations:[],
      sosOrganization:[], //multiple
      units:[],
    }
  },
  created(){
    for(let i=new Date().getFullYear(); i>=1993;i--){
      this.years.push(i);
    }
    for(let i=0;i<=10;i++){
      this.cargoHolds.push(i+" Compartment");
    }
    this.loadShips();
    this.$http.get('getShipType',).then(response=>{
      this.shipTypes=response.data;
    });
    this.$http.get('getShipCategory',).then(response=>{
      this.shipCategories=response.data;
    });
    this.$http.get('getProduct',).then(response=>{
      this.products=response.data;
    });
    this.$http.get('getRoute',).then(response=>{
      this.routes=response.data;
    });
    this.$http.get('getShipGroup',).then(response=>{
      this.shipGroups=response.data;
    });
    this.$http.get('getPortGroup',).then(response=>{
      this.shipPortGroups=response.data;
    });
    this.$http.get('getSOSOrganization',).then(response=>{
      this.sosOrganizations=response.data;
    });
    this.$http.get('getUnit',).then(response=>{
      this.units=response.data;
    });
  },
  methods:{
    loadShips(){
      this.$http.post('myEditableShips',{
        'username':window.localStorage.username,
        'password':window.localStorage.password
        }).then(response=>{
        this.ships=response.data;
      });
    },
    shipChanged(){
      let Ship;
      if(this.shipId!=''){
        for(const _ship of this.ships){
          if(_ship.id==this.shipId){
            Ship=_ship;
            break;
          }
        }
        if(Ship!=null){
          this.shipName=Ship.ship_name;
          this.mNumber=Ship.m_number;
          if(Ship.ship_capacity.length>0){
            for(const cap of Ship.ship_capacity){
              this.shipCapacity[cap.id]=cap.pivot.capacity;
            }
          }
          this.shipType=Ship.ship_type_id;
          if(Ship.ship_category.length>0){
            const cats=[];
            for(const cat of Ship.ship_category){
              cats.push(cat.id);
            }
            this.shipCategory=cats;
          }
          this.buildYear=Ship.build_year;
          this.maxDraft=Ship.max_draft_ft;
          this.length=Ship.length;
          this.beam=Ship.beam;
          this.grossTonnage=Ship.gross_tonnage;
          this.cargoHold=Ship.cargo_hold;
          this.fitnessCertificate=Ship.fitness_certificate.toString();
          this.fitnessCertificateDetails=Ship.fitness_certificate_details;
          this.fitnessExpireDate=Ship.fitness_expire_date;
          if(Ship.ship_products.length>0){
            const pro=[];
            for(const prod of Ship.ship_products){
              pro.push(prod.id);
            }
            this.product=pro;
          }
          if(Ship.ship_route.length>0){
            const rou=[];
            for(const rout of Ship.ship_route){
              rou.push(rout.id);
            }
            this.route=rou;
          }
          if(Ship.ship_groups.length>0){
            const gro=[];
            for(const grou of Ship.ship_groups){
              gro.push(grou.id);
            }
            this.shipGroup=gro;
          }
          if(Ship.port_group.length>0){
            this.shipPortGroup=Ship.port_group[0].id;
          }
          if(Ship.sos_organization.length>0){
            const sosor=[];
            for(const sosorg of Ship.sos_organization){
              sosor.push(sosorg.id);
            }
            this.sosOrganization=sosor;
          }
          this.surveyExpireDate=Ship.survey_expire_date;
          this.insuranceExpireDate=Ship.insurance_expire_date;
          this.bayCrossingExpireDate=Ship.bay_crossing_expire_date;
          this.protocolExpireDate=Ship.protocol_expire_date;
        }
      }else{
        console.log("No Ship Found");
      }
    },
    clearDateTime(event){
      event.target.value='';
    },
    removeTimeString(date){
      if(date=='' || date==null){
        return '';
      }
      return new Date(date).toISOString().split('T')[0];
    },
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async save(){
      const shipCapacity=[];
      const keys= Object.keys(this.shipCapacity);
      for(const key of keys){
        shipCapacity.push('"'+key+'":"'+this.shipCapacity[key]+'"');
      }
      if(keys.length==0){
        for(const unit of this.units){
          shipCapacity.push('"'+unit.id+'":""');
        }
      }
      let shipCapacity_=shipCapacity.join(',');
      shipCapacity_=JSON.parse(`{`+shipCapacity_+`}`);
      
      // for(const capasity,i of this.shipCapacity){
      //   shipCapacity[i]=capasity;
      // }
      // console.log(shipCapacity);
      // console.log(JSON.stringify(shipCapacity));
      if(this.shipName=='' || this.shipName==null){
        this.presentAlert('Ship Name');
        return;
      }
      if(this.mNumber=='' || this.mNumber==null){
        this.presentAlert('M Number');
        return;
      }
      for(const unit of this.units){
        if(this.shipCapacity[unit.id]=='' || this.shipCapacity[unit.id]==null){
          this.presentAlert(unit.unit_name);
          return;
        }
      }
      if(this.shipType=='' || this.shipType==null){
        this.presentAlert('Ship Type');
        return;
      }
      if(this.maxDraft=='' || this.maxDraft==null){
        this.presentAlert('Draft');
        return;
      }
      if(this.length=='' || this.length==null){
        this.presentAlert('Length');
        return;
      }
      if(this.beam=='' || this.beam==null){
        this.presentAlert('Beam');
        return;
      }
      if(this.fitnessCertificate==1 && (this.fitnessCertificateDetails=='' || this.fitnessCertificateDetails==null)){
        this.presentAlert('Fitness Certificate Details');
        return;
      }else if(this.fitnessCertificate==1 && this.fitnessCertificateDetails.length<6){
        this.presentResponseAlert('Alert','Fitness Certificate Details must be at least 6 Charecters');
        return;
      }
      if(this.fitnessCertificate==1 && (this.fitnessExpireDate=='' || this.fitnessExpireDate==null)){
        this.presentAlert('Fitness Certificate Expire Date');
        return;
      }
      if(this.product==null || this.product.length==0){
        this.presentAlert('Ship Products');
        return;
      }
      if(this.route==null || this.route.length==0){
        this.presentAlert('Ship Routes');
        return;
      }
      if(this.shipGroup==null || this.shipGroup.length==0){
        this.presentAlert('Ship Groups');
        return;
      }
      if(this.shipPortGroup=='' || this.shipPortGroup==null){
        this.presentAlert('Ship SMS Port Group');
        return;
      }
      if(this.sosOrganization==null || this.sosOrganization.length==0){
        this.presentAlert('SOS Organization');
        return;
      }
      const data={
        'ship_name':this.shipName,
        'm_number':this.mNumber,
        'capacity':shipCapacity_,
        'ship_type_id':this.shipType,
        'ship_category_id':this.shipCategory,
        'build_year':this.buildYear,
        'max_draft_ft':this.maxDraft,
        'length':this.length,
        'beam':this.beam,
        'gross_tonnage':this.grossTonnage,
        'cargo_hold':this.cargoHold,
        'fitness_certificate':this.fitnessCertificate,
        'fitness_certificate_details':this.fitnessCertificateDetails,
        'fitness_expire_date':this.removeTimeString(this.fitnessExpireDate),
        'product_id':this.product,
        'route_id':this.route,
        'ship_group_id':this.shipGroup,
        'port_group_id':this.shipPortGroup,
        'sos_organization_id':this.sosOrganization,
        'survey_expire_date':this.removeTimeString(this.surveyExpireDate),
        'insurance_expire_date':this.removeTimeString(this.insuranceExpireDate),
        'bay_crossing_expire_date':this.removeTimeString(this.bayCrossingExpireDate),
        'protocol_expire_date':this.removeTimeString(this.protocolExpireDate),
        'username':window.localStorage.username,
        'password':window.localStorage.password,
      };
      // console.log(data);
      this.$http.post('updateShip/'+this.shipId,data).then(async response=>{
        if(response.status==200){
          this.presentResponseAlert('Success','Ship Updated Successfully');
          this.shipName='';
          this.mNumber='';
          this.shipCapacity=[];
          this.buildYear='';
          this.maxDraft='';
          this.length='';
          this.beam='';
          this.grossTonnage='';
          this.cargoHold='';
          this.fitnessCertificate='';
          this.fitnessCertificateDetails='';
          this.fitnessExpireDate='';
          this.surveyExpireDate='';
          this.insuranceExpireDate='';
          this.bayCrossingExpireDate='';
          this.protocolExpireDate='';
          this.shipType=null;
          this.shipCategory=[];//multiple
          this.product=[]; //multiple
          this.route=[]; //multiple
          this.shipGroup=[]; //multiple
          this.shipPortGroup=null;
          this.sosOrganization=[]; //multiple
          this.loadShips();
          this.shipId='';
        }else{
          let errors= response.data.errors;
          errors=errors.join('<br>');
          this.presentResponseAlert('Failed',errors);
        }
      });      
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    }
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonInput,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonDatetime,
    IonText,
    IonTextarea

  }
  
}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
</style>
